/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Card, Col, ProgressBar, Row, Spinner, Table } from "react-bootstrap";

import complianceService from "../../api/atendimentos/complianceService";
import { formataDataExibicao } from "../../common/utils";

const VARIANTES_CLASSIFICACAO = {
    aderente: "success",
    atencao: "warning",
    risco: "danger",
};

const varianteScore = (valor) => {
    if (valor === null || valor === undefined) return "secondary";
    if (valor >= 90) return "success";
    if (valor >= 70) return "warning";
    return "danger";
};

class ComplianceLinhaCuidadoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = { loading: true, erro: "", dados: null };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, dados: null });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await complianceService.consolidado(atendimentoId);
            this.setState({ loading: false, dados: response.data || null });
        } catch (error) {
            console.error("Erro ao carregar compliance da Linha de Cuidado:", error);
            const data = error?.response?.data;
            const mensagem =
                (data && typeof data === "object" && Array.isArray(Object.values(data)[0])
                    ? Object.values(data)[0][0]
                    : null) || "Não foi possível carregar os indicadores de compliance.";
            this.setState({ loading: false, erro: mensagem });
        }
    };

    renderIndicador = (titulo, formula, valor, realizados, previstos, rotuloUnidade, detalhe) => (
        <Col sm={12} lg={4} className="mb-3">
            <Card className="h-100">
                <Card.Body>
                    <h6 className="mb-1">{titulo}</h6>
                    <small className="text-muted d-block mb-2">{formula}</small>
                    {valor === null || valor === undefined ? (
                        <Alert variant="light" className="mb-0 py-2">
                            <small>{detalhe || "Sem base de cálculo."}</small>
                        </Alert>
                    ) : (
                        <>
                            <div className="d-flex justify-content-between align-items-end mb-1">
                                <span className="h4 mb-0">{valor}%</span>
                                <small className="text-muted">
                                    {realizados} de {previstos} {rotuloUnidade}
                                </small>
                            </div>
                            <ProgressBar now={valor} variant={varianteScore(valor)} />
                        </>
                    )}
                </Card.Body>
            </Card>
        </Col>
    );

    renderGeral = () => {
        const { dados } = this.state;
        const geral = dados?.geral;

        if (!geral) {
            return null;
        }

        const pesos = geral.pesos_aplicados || {};
        const referencia = geral.pesos_referencia || {};

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <Row className="align-items-center">
                        <Col sm={12} lg={5}>
                            <h5 className="mb-1">Compliance Geral da Linha de Cuidado</h5>
                            <small className="text-muted">
                                Medicamentoso {referencia.medicamentoso}% · Consultas {referencia.consultas}% · Laboratorial{" "}
                                {referencia.laboratorial}%
                            </small>
                        </Col>
                        <Col sm={12} lg={7}>
                            {geral.score === null ? (
                                <Alert variant="light" className="mb-0">
                                    {geral.detalhe}
                                </Alert>
                            ) : (
                                <>
                                    <div className="d-flex justify-content-between align-items-end mb-1">
                                        <span className="display-6 mb-0">{geral.score}%</span>
                                        <Badge bg={VARIANTES_CLASSIFICACAO[geral.classificacao] || "secondary"} className="fs-6">
                                            {geral.classificacao_display}
                                        </Badge>
                                    </div>
                                    <ProgressBar now={geral.score} variant={varianteScore(geral.score)} />
                                    <small className="text-muted d-block mt-2">
                                        Faixas: ≥ 90% aderente · 70% a 89% em atenção · abaixo de 70% de risco
                                    </small>
                                </>
                            )}
                        </Col>
                    </Row>

                    {(geral.componentes_ignorados || []).length > 0 && geral.score !== null && (
                        <Alert variant="info" className="mt-3 mb-0">
                            <small>
                                Sem base de cálculo para: <strong>{geral.componentes_ignorados.join(", ")}</strong>. Os pesos
                                foram redistribuídos entre os indicadores disponíveis (
                                {Object.entries(pesos)
                                    .map(([chave, peso]) => `${chave} ${peso}%`)
                                    .join(" · ")}
                                ).
                            </small>
                        </Alert>
                    )}
                </Card.Body>
            </Card>
        );
    };

    renderDetalheLaboratorial = () => {
        const { dados } = this.state;
        const detalhes = dados?.laboratorial?.detalhes_por_exame || [];

        if (detalhes.length === 0) {
            return null;
        }

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h6 className="mb-3">Compliance Laboratorial por exame</h6>
                    <Table responsive className="custom-table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Exame</th>
                                <th>Periodicidade</th>
                                <th>Previstos</th>
                                <th>Realizados</th>
                                <th>Compliance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {detalhes.map((item) => (
                                <tr key={item.exame_id}>
                                    <td>{item.exame}</td>
                                    <td>{item.periodicidade_display}</td>
                                    <td>{item.exames_previstos}</td>
                                    <td>{item.exames_realizados}</td>
                                    <td>
                                        <Badge bg={varianteScore(item.compliance)}>
                                            {item.compliance === null ? "-" : `${item.compliance}%`}
                                        </Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {dados?.laboratorial?.data_inicio_referencia && (
                        <small className="text-muted d-block mt-2">
                            Contagem a partir de {formataDataExibicao(dados.laboratorial.data_inicio_referencia)} (entrada do
                            paciente na Linha de Cuidado).
                        </small>
                    )}
                </Card.Body>
            </Card>
        );
    };

    render() {
        const { loading, erro, dados } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        if (!dados) {
            return null;
        }

        const { medicamentoso, consultas, laboratorial } = dados;

        return (
            <>
                {this.renderGeral()}

                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <h6 className="mb-3">Indicadores</h6>
                        <Row>
                            {this.renderIndicador(
                                "Compliance Medicamentoso",
                                "Tratamentos realizados ÷ previstos × 100",
                                medicamentoso?.compliance,
                                medicamentoso?.tratamentos_realizados,
                                medicamentoso?.tratamentos_previstos,
                                "tratamentos",
                                "Nenhum medicamento com periodicidade projetável."
                            )}
                            {this.renderIndicador(
                                "Compliance de Consultas",
                                "Consultas realizadas ÷ previstas × 100",
                                consultas?.compliance,
                                consultas?.consultas_realizadas,
                                consultas?.consultas_previstas,
                                "consultas",
                                consultas?.detalhe
                            )}
                            {this.renderIndicador(
                                "Compliance Laboratorial",
                                "Exames realizados ÷ previstos × 100",
                                laboratorial?.compliance,
                                laboratorial?.exames_realizados,
                                laboratorial?.exames_previstos,
                                "exames",
                                laboratorial?.detalhe
                            )}
                        </Row>
                        {consultas?.frequencia_display && (
                            <small className="text-muted">
                                Consultas previstas pela frequência de acompanhamento cadastrada:{" "}
                                <strong>{consultas.frequencia_display}</strong>.
                            </small>
                        )}
                    </Card.Body>
                </Card>

                {this.renderDetalheLaboratorial()}
            </>
        );
    }
}

export default ComplianceLinhaCuidadoAtendimento;
